import React from 'react';
import { logoLink, navLinks } from '../constants';
import { Services } from './Services';

const publicUrl = process.env.PUBLIC_URL || '';

export const Navbar: React.FC = () => (
  <div className="header-pill">
    <div className="header-pill-left">
      <Services />
    </div>
    <div className="header-pill-center">
      <a href={logoLink} className="header-nav-logo" aria-label="Rock'n'Block" target="_blank" rel="noopener noreferrer">
        <img src={`${publicUrl}/rnb_logo.svg`} alt="" width={32.5} height={32.5} />
      </a>
    </div>
    <nav className="header-pill-right">
      {navLinks.map(({ title, href }) => (
        <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="header-nav-item">
          {title}
        </a>
      ))}
    </nav>
  </div>
);
